<template>
  <table class="tableizer-table text-center">
    <thead>
      <tr class="tableizer-firstrow">
        <th /><th>Anti-feu</th><th>Anti-rongeurs</th><th>Légèreté</th><th>Résistance</th><th>Facilité au tirage</th>
      </tr>
    </thead><tbody>
      <tr>
        <td class="text-left">
          FIBRE STRUCTURE SERRÉE STANDARD<br>
          Câble interieur/extérieur classique 900µ LSZH
        </td><td>3</td><td>1</td><td>4</td><td>2</td><td>2</td>
      </tr>
      <tr>
        <td class="text-left">
          FIBRE STRUCTURE SERRÉE RENFORCÉE<br>
          Câble interieur/extérieur renforcé 900µm LSZH - Belden
        </td><td>4</td><td>3</td><td>3</td><td>4</td><td>3</td>
      </tr>
      <tr>
        <td class="text-left">
          FIBRE STRUCTURE LIBRE<br>
          Câble intérieur/extérieur à structure libre 250µ  LSZH
        </td><td>3</td><td>2</td><td>5</td><td>1</td><td>4</td>
      </tr>
      <tr>
        <td class="text-left">
          FIBRE STRUCTURE LIBRE ARMÉE ACIER<br>
          Câble extérieur à structure libre armé acier LSZH
        </td><td>3</td><td>5</td><td>1</td><td>5</td><td>5</td>
      </tr>
      <tr>
        <td class="text-left">
          FIBRE BREAK OUT<br>
          Câble intérieur à structure Break Out LSZH
        </td><td>3</td><td>0</td><td>1</td><td>3</td><td>nc*</td>
      </tr>
    </tbody>
    <caption
      align="bottom"
      class="text-xs"
    >
      * Cette donnée dépend essentiellement du nombre de gaines 2mm à l'intérieur du trunk optique. Pour cette raison, nous ne pouvons pas la comparer aux autres types de gaines.
    </caption>
  </table>
</template>

<script>
export default {
  name: 'GaineComparison',
};
</script>

<style lang="scss">
  table td {
    text-align: center !important;
  }

  table th {
    text-align: center !important;
  }
</style>
